import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CmxWebComponentsModule } from '@cmx-web-components/angular';

// Components
import { GlobalFiltersComponent } from './container/global-filters.component';
import { SelectJobsiteModalComponent } from './components/select-jobsite-modal/select-jobsite-modal.component';

// Pipes
import { SelectedPipe } from './pipes/selected.pipe';
import { FilterJobsitesPipe } from './pipes/filter-jobsites.pipe';
import { FormatJobsitePipe } from './pipes/format-jobsite.pipe';

// Services

@NgModule({
  declarations: [
    GlobalFiltersComponent,
    SelectJobsiteModalComponent,
    SelectedPipe,
    FilterJobsitesPipe,
    FormatJobsitePipe,
  ],
  imports: [CommonModule, TranslateModule, CmxWebComponentsModule],
  exports: [GlobalFiltersComponent, SelectedPipe, FilterJobsitesPipe, SelectJobsiteModalComponent, FormatJobsitePipe],
})
export class GlobalFiltersComponentModule {}
